import { defineStore } from 'pinia';
import router from '@/router';
import { Jwt } from '@/types/jwt';
import {Auth} from '@/types/stores';
import { jwtDecode } from 'jwt-decode';
import publicPages from '@/constants/publicPages';
import { useSplit } from '@/composables/useSplit';
const { client } = useSplit();

export const useAuthStore = defineStore({
  id: 'auth',
  state: () => ({
    user: null,
    token: null,
    returnUrl: null
  }) as Auth,
  actions: {
    async login() {
      if (this.isLoginvalid()) {
        client.on(client.Event.SDK_READY, async () => {
          const treatment = await client.getTreatment('PM_ssnv_instant_card_verification');
    
          if (treatment === 'on') {
            router.push({ name: 'select-verification' });
          } else {
            router.push({ name: 'ssn-verification' });
          }
        });
        return;
      }
      const cognitoUrl = process.env.VUE_APP_SSNV_APP_COGNITO_URL; //'https://aaops-ssnv-test.auth.us-east-1.amazoncognito.com' //process.env.VUE_APP_COGNITO_URL;
      const cognitoClientId = process.env.VUE_APP_SSNV_APP_COGNITO_CLIENT_ID; //'6tt79ql1nsc97dufglgmsmsqqq' //process.env.VUE_APP_COGNITO_CLIENT_ID;
      const callbackUrl = process.env.VUE_APP_SSNV_APP_COGNITO_CALLBACK_URL; //'http://localhost:3000/';
      const redirectUrl = `${cognitoUrl}/login?response_type=token&client_id=${cognitoClientId}&redirect_uri=${callbackUrl}`;
      window.location.href = redirectUrl;
    },
    logout() {
      this.token = null;
      this.user = null;
      this.returnUrl = null;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      router.push('/auth/login');
    },
    setToken(token: string) {
      this.token = token;
      localStorage.setItem('token', token);
      const decodedUser: Jwt = jwtDecode<Jwt>(token);
      this.setUser(decodedUser);
    },
    setUser(user:Jwt) {
      this.user = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    getUser(): Jwt | null {
      if(this.user == null) {
        if (localStorage.getItem('user')) {
          this.user = JSON.parse(localStorage.getItem('user') as string);
        }
        else {
          return router.push('/auth/login') as unknown as null;
        }
      } 
      return this.user;
    },
    getToken(): string | null {
      if(this.token == null) {
        if (localStorage.getItem('token')) {
          this.token = localStorage.getItem('token');
        }
        else {
          return router.push('/auth/login') as unknown as null;
        }
      } 
      return this.token;
    },
    isLoginvalid() : boolean {
      const token = localStorage.getItem('token');
      if (!token) {
        return false;
      }
      return true;
    },
    isAuthRequired(name: string) : boolean {
      return !publicPages.includes(name);
    }
  }
});
